// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/ui/tabs.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/ui/tabs.tsx");
  import.meta.hot.lastModified = "1717182690461.413";
}
// REMIX HMR END

import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "~/utils/utils";
const Tabs = TabsPrimitive.Root;
const TabsList = React.forwardRef(_c = ({
  className,
  ...props
}, ref) => <TabsPrimitive.List ref={ref} className={cn("inline-flex items-center gap-4 md:gap-16 justify-center w-full border-b border-neutral-300", className)} {...props} />);
_c2 = TabsList;
TabsList.displayName = TabsPrimitive.List.displayName;
const TabsTrigger = React.forwardRef(_c3 = ({
  className,
  ...props
}, ref) => <TabsPrimitive.Trigger ref={ref} className={cn("inline-flex items-center justify-center text-sm md:text-base whitespace-nowrap focus-visible:outline-none text-neutral-500 data-[state=active]:text-secondary-700 data-[state=active]:border-b-2 data-[state=active]:border-secondary-700 pb-3", className)} {...props} />);
_c4 = TabsTrigger;
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
const TabsContent = React.forwardRef(_c5 = ({
  className,
  ...props
}, ref) => <TabsPrimitive.Content ref={ref} className={cn("ring-offset-background focus-visible:outline-none flex flex-col items-center justify-center", className)} {...props} />);
_c6 = TabsContent;
TabsContent.displayName = TabsPrimitive.Content.displayName;
export { Tabs, TabsList, TabsTrigger, TabsContent };
var _c, _c2, _c3, _c4, _c5, _c6;
$RefreshReg$(_c, "TabsList$React.forwardRef");
$RefreshReg$(_c2, "TabsList");
$RefreshReg$(_c3, "TabsTrigger$React.forwardRef");
$RefreshReg$(_c4, "TabsTrigger");
$RefreshReg$(_c5, "TabsContent$React.forwardRef");
$RefreshReg$(_c6, "TabsContent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;